import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { APP_BASE } from './config/basePath'
import { loadHostBinding } from './config/hostBinding'
import { installStaleBuildRecovery } from './lib/staleBuild'
import { bootBrowserTest } from './testing/browserTestBoot'
import { reactRootErrorOptions } from '@twasta/page-runtime/support/errorRing'
import './styles/globals.css'

// A tab left open across a rebuild asks for chunk names the new build deleted
// ('Failed to fetch dynamically imported module'). Recover by reloading once.
installStaleBuildRecovery()

// Every render error — caught by a boundary or not — also goes to the Support
// module's error ring, so an issue report carries the crash the reporter saw.
const root = ReactDOM.createRoot(document.getElementById('root')!, reactRootErrorOptions())

function render() {
  root.render(
  <React.StrictMode>
    {/* useTransitions={false}: React Router v7 wraps every
        location update in startTransition() by default, which means
        navigations become non-urgent and can be deferred indefinitely
        if any concurrent work (e.g. live-preview debounced saves) is
        pending. The "Open Editor" button stuck on the smart-doc Live
        Preview tab was a direct symptom — history.pushState succeeded
        but the Router's setState transition never committed until
        another state change forced a flush. Opting back into urgent
        updates restores synchronous routing. */}
    <BrowserRouter basename={APP_BASE} useTransitions={false}>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
  )
}

// In production the server has already written the host binding into the
// document (see config/hostBinding), so this renders immediately. Only the
// split dev server — where index.html comes from Vite and nothing injected
// anything — pays a round trip, and only once at boot.
// A tab opened from a browser-driven test run's start link loads the test
// runner first (testing/browserTestBoot); every other tab skips straight on.
const testRun = bootBrowserTest()
const boot = () => {
  if (import.meta.env.DEV && !window.__TWASTA_HOST__) {
    loadHostBinding().finally(render)
  } else {
    render()
  }
}
if (testRun) testRun.finally(boot)
else boot()
